{
  "dropzoneLabel": "ドロップゾーン",
  "selectPlaceholder": "項目を選択",
  "tableResizer": "サイズ変更ツール",
  "colorSwatchPicker": "Color swatches"
}
